import type {
    ShareAccessScope,
    ShareInvitationBatchResponse,
    ShareInvitationResultResponse,
    ShareMemberResponse,
} from '@telecom/shared/infrastructure/api-functions/public-share-api';

/** 分享弹窗初始化数据。 */
export interface ReportShareConfiguration {
    /** 分享 ID。 */
    shareId: string;
    /** 可复制的完整分享链接。 */
    shareUrl: string;
    /** 当前访问范围。 */
    accessScope: ShareAccessScope;
    /** Owner 和显式邀请成员。 */
    members: ShareMemberResponse[];
}

/** 报告定向分享服务。 */
export interface ReportShareService {
    /** 创建或读取当前任务分享，并加载弹窗配置。 */
    initialize(): Promise<ReportShareConfiguration>;
    /** 批量邀请邮箱。 */
    invite(shareId: string, emails: string[]): Promise<ShareInvitationBatchResponse>;
    /** 重发一条邀请。 */
    resend(shareId: string, invitationId: string): Promise<ShareInvitationResultResponse>;
    /** 移除一条邀请。 */
    remove(shareId: string, invitationId: string): Promise<void>;
    /** 更新访问范围。 */
    updateAccessScope(shareId: string, accessScope: ShareAccessScope): Promise<ShareAccessScope>;
}

export const ReportShareService = Symbol.for('ReportShareService');
